import axiosInstance from './axiosInstance';

const API_URL = process.env.REACT_APP_API_URL;

// Retrieve the current user's profile
export const getUserProfile = async () => {
  try {
    const response = await axiosInstance.get(`${API_URL}/user-profile`);
    return response.data;
  } catch (error) {
    console.error("Error fetching user profile:", error.response?.data || error);
    throw error;
  }
};

// Update the current user's profile
export const updateUserProfile = async (profileData) => {
  try {
    const response = await axiosInstance.put(`${API_URL}/user-profile`, profileData);
    return response.data;
  } catch (error) {
    console.error("Error updating user profile:", error.response?.data || error);
    throw error;
  }
};

// Delete (deactivate) the current user's account
export const deleteUserAccount = async () => {
  try {
    const response = await axiosInstance.delete(`${API_URL}/user-profile`);
    return response.data;
  } catch (error) {
    console.error("Error deleting user account:", error.response?.data || error);
    throw error;
  }
};
